import { render, staticRenderFns } from "./NoteModal.vue?vue&type=template&id=60453296&scoped=true&"
import script from "./NoteModal.vue?vue&type=script&lang=ts&"
export * from "./NoteModal.vue?vue&type=script&lang=ts&"
import style0 from "./NoteModal.vue?vue&type=style&index=0&id=60453296&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60453296",
  null
  
)

export default component.exports